import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { Form, Input, Button, Typography, message } from "antd";
import axios from "axios";
import { UserContext } from "../../../context/UserContext";
import { useNavigate } from "react-router-dom";
import SummaryApi from "../../../common/index";
import logo from "../../../Assets/logo.gif";
import "../../../Styles/SellerStylings/SellerLogin.css";
 
const { Title } = Typography;
 
function SellerLogin() {
  const { login } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
 
  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await axios.post(SummaryApi.sellerLogin.url, values);
      const { seller, token, message: msg } = res.data;
      if (token && seller.status === "active") {
        login(seller, token, "seller");
        message.success("Login successful!");
        navigate("/seller/dashboard");
      } else {
        message.warning(msg);
      }
    } catch (err) {
      message.error(err.response?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <div className="seller-login-outer">
      {/* Centered logo above card */}
      <img
        src={logo}
        alt="MedKart Logo"
        className="seller-login-logo"
      />
      {/* Centered card below logo */}
      <div className="seller-login-card">
        <Title level={2} style={{ textAlign: "center" }}>Seller Login</Title>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item label="Email or Mobile" name="login" rules={[{ required: true }]}>
            <Input placeholder="Email or Mobile" style={{ padding: "8px" }} />
          </Form.Item>
          <Form.Item label="Password" name="password" rules={[{ required: true }]}>
            <Input.Password placeholder="Password" style={{ padding: "8px" }} />
          </Form.Item>

          <Form.Item>
              <div style={{ textAlign: "right", marginBottom: "15px" }}>
              <Link to="/forgot-password" style={{ fontSize: "14px" }}>
                Forgot Password?
              </Link>
            </div>
            <Button type="primary" htmlType="submit" block loading={loading}
              style={{ background: "red", height: "40px", margin: 0 }}>
              Login
            </Button>
  
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
 
export default SellerLogin;